import { Pipe, PipeTransform } from '@angular/core';

import { formatBytes } from './format-bytes';

@Pipe({
    name: 'bytes',
    standalone: false
})
export class BytesPipe implements PipeTransform {
   transform(value: number, decimals = 2) {
      if (!value) {
         return value;
      }
      return formatBytes(value, decimals);
   }
}
